class NavItem {
  to = { name: '' }
  key = ''
  permissions = []
  isDivider = false
  text = ''
  children = null

  constructor (
    to = { name: '' },
    key,
    permissions = [],
    isDivider = false,
    children = null,
    text
  ) {
    this.to = to
    this.key = key
    this.permissions = permissions
    this.isDivider = isDivider
    this.text = text
    this.children = children
  }
}

const navListSideBarList = [
  new NavItem({ name: 'page-places' }, 'places', ['READ_PLACE'], false, [
    new NavItem({ name: 'page-places' }, 'places', ['READ_PLACE']),
    new NavItem({ name: 'page-places-categories' }, 'places-categories', [
      'READ_PLACECATEGORY'
    ])
  ]),
  new NavItem({ name: 'page-blog-posts' }, 'blog-posts', ['READ_BLOGPOST'], false, [
    new NavItem({ name: 'page-blog-posts' }, 'blog-posts', ['READ_BLOGPOST']),
    new NavItem({ name: 'page-blog-categories' }, 'blog-categories', [
      'READ_BLOGCATEGORY'
    ])
  ]),
  new NavItem({ name: 'page-info-pages' }, 'info-pages', ['READ_INFOPAGE'], false, [
    new NavItem({ name: 'page-info-pages' }, 'info-pages', ['READ_INFOPAGE']),
    new NavItem({ name: 'page-info-categories' }, 'info-categories', ['READ_INFOPAGE'])
  ]),
  new NavItem(
    { name: 'page-personal-details' },
    'personal-details',
    ['READ_PAGE'],
    false,
    [
      new NavItem({ name: 'page-personal-details' }, 'personal-details', ['READ_PAGE']),
      new NavItem({ name: 'page-legal-details' }, 'legal-details', ['READ_PAGE'])
    ]
  ),
  new NavItem({ name: 'page-orders-event' }, 'orders-event', ['READ_PLACE'], false, [
    new NavItem({ name: 'page-orders-event' }, 'orders-event', ['READ_PLACE']),
    new NavItem({ name: 'page-orders-booking' }, 'orders-booking', ['READ_PLACE'])
  ]),
  new NavItem({ name: 'page-cities' }, 'cities', ['READ_CITY']),
  new NavItem({ name: 'page-pages' }, 'pages', ['READ_PAGE']),

  new NavItem({ name: 'page-hotels' }, 'hotels', ['READ_BLOGPOST']),
  new NavItem({ name: 'page-guides' }, 'guides', ['READ_GUIDE']),
  new NavItem({ name: 'page-tourist-agencies' }, 'tourist-agencies', ['READ_PAGE']),
  new NavItem({ name: 'page-event-organizers' }, 'event-organizers', ['READ_PAGE']),
  new NavItem({ name: 'page-routes' }, 'routes', ['READ_ROUTE']),
  new NavItem({ name: 'page-audioguides' }, 'audioguides', ['READ_AUDIOGUIDE']),
  new NavItem({ name: 'page-historical-figures' }, 'historical-figures', ['READ_PAGE']), // !FOR DEV!
  new NavItem({ name: 'page-cultural-organizations' }, 'cultural-organisations', [
    'READ_PAGE'
  ]), // !FOR DEV!
  new NavItem(null, '', ['READ_ACCOUNT', 'READ_ROLE'], true),
  new NavItem({ name: 'page-accounts' }, 'accounts', ['READ_ACCOUNT']),
  new NavItem({ name: 'page-roles' }, 'roles', ['READ_ROLE']),
  new NavItem({ name: 'page-shared-access' }, 'shared-access', ['READ_ACCOUNT']),
  new NavItem(null, '', ['READ_KIOSK', 'READ_STREAM'], true),
  new NavItem({ name: 'page-kiosk-devices' }, 'kiosk-devices', ['READ_KIOSK']),
  new NavItem({ name: 'page-streams' }, 'streams', ['READ_KIOSK', 'READ_STREAM']), // mock READ_KIOSK
  new NavItem(null, '', ['READ_PAGE'], true), // !FOR DEV!
  new NavItem({ name: 'page-ad-placements' }, 'ad-placements', ['READ_PAGE']), // !FOR DEV!
  new NavItem(null, '', ['READ_FILE', 'READ_DICTIONARY', 'READ_DICTIONARYOPTION'], true),
  new NavItem({ name: 'page-media-library' }, 'media-library', ['READ_FILE']),
  new NavItem({ name: 'page-dictionaries' }, 'dictionaries', ['READ_DICTIONARY']),
  new NavItem({ name: 'page-seo-configs' }, 'seo-configs', ['READ_PAGE']), // !FOR DEV!
  new NavItem(null, '', ['READ_DICTIONARY'], true),
  new NavItem({ name: 'page-actions-dictionary' }, 'actionsDictionary', [
    'READ_DICTIONARY'
  ])
]
export default navListSideBarList

export const navListDashboard = [
  new NavItem({ name: 'page-events' }, 'events', ['READ_EVENT']),
  ...navListSideBarList
]
